<template>
  <div v-if="headers" class="iptest">
    <div>accept-encoding: {{ headers['accept-encoding'] }}</div>
    <div>accept-language: {{ headers['accept-language'] }}</div>
    <div>cache-control: {{ headers['cache-control'] }}</div>
    <div>host: {{ headers['host'] }}</div>
    <div>pragma: {{ headers['pragma'] }}</div>
    <div>referer: {{ headers['referer'] }}</div>
    <div>user-agent: {{ headers['user-agent'] }}</div>
    <div>via: {{ headers['via'] }}</div>
    <div>x-appengine-city: {{ headers['x-appengine-city'] }}</div>
    <div>x-appengine-citylatlong: {{ headers['x-appengine-citylatlong'] }}</div>
    <div>x-appengine-country: {{ headers['x-appengine-country'] }}</div>
    <div>x-appengine-region: {{ headers['x-appengine-region'] }}</div>
    <div>x-cloud-trace-context: {{ headers['x-cloud-trace-context'] }}</div>
    <div>x-forwarded-for: {{ headers['x-forwarded-for'] }}</div>
    <div>x-forwarded-proto: {{ headers['x-forwarded-proto'] }}</div>

  </div>
</template>

<script>

export default {
  props: [],
  data() {
    return {
      ipTestData: undefined,
    };
  },
  components: {},
  mounted() {
    this.requestTestData();
  },
  computed: {
    headers() {
      return this.ipTestData && this.ipTestData.headers;
    },
  },
  methods: {
    requestTestData() {
      if (!$) return setTimeout(() => this.requestTestData(), 1000);
      const self = this;
      const BASE_SVC_URL = `https://mikmak-microservices.appspot.com`;

      /* eslint-disable no-console */
      $.ajax({
        url: BASE_SVC_URL,
        type: 'GET',
        success: function(data) {
          self.ipTestData = data;
          console.log(data);
        },
        error: function(xhr, desc, err) {
          console.log('Error response from microservices');
          console.log(err);
        },
      });
    },
  },
  watch: {},
};

</script>

<style scoped>

  .iptest {
    margin: 0;
    font-size: 12px;
    font-family: Arial,
                 'avenir next', avenir,
                 helvetica, 'helvetica neue',
                 Ubuntu,
                 'segoe ui', arial,
                 sans-serif;
  }

  .iptest div {
    margin: 12px;
    background: #f1f0f0;
    padding: 4px;
  }

</style>
